import _ from 'lodash';
import raw_decode from 'jwt-decode';

export function jwt_decode( jwt_token ) {
  if ( _.isPlainObject( jwt_token ) && _.isString( jwt_token.accessToken ) ) {
    jwt_token = jwt_token.accessToken;
  }
  const token = { rawToken : jwt_token };
  try {
    _.assign( token, raw_decode( jwt_token ) );
    if ( token.iat ) token.issued = new Date( token.iat * 1000 );
    if ( token.exp ) {
      const exp = token.exp * 1000;
      token.expires = new Date( exp );
      Reflect.defineProperty( token, 'expired', {
        get() { return Date.now() > exp; },
      } );
    }
    token.authenticated = Boolean( token.memberId );
    return token;
  } catch( error ) {
    return _.assign( token, { error } );
  }
}
